import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#0b72b9' },
    secondary: { main: '#f05a28' },
    background: { default: '#ffffff' }
  },
  typography: {
    fontFamily: ['Poppins', 'Open Sans', 'Helvetica', 'Arial', 'sans-serif'].join(','),
    h1: { fontWeight: 800, fontSize: '2.5rem' },
    h2: { fontWeight: 700, fontSize: '2rem' },
    h3: { fontWeight: 700 },
    h4: { fontWeight: 700 },
    body1: { fontSize: '1rem' }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <App />
  </ThemeProvider>
);
